import React from 'react';

const Footer = () => {
  return (
    <footer className="fixed bottom-0 right-0 left-0 lg:left-64 z-40 bg-white border-t border-gray-200">
      <div className="h-16 px-4 flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <span className="text-sm text-gray-500"> 2024 Procureria. All rights reserved.</span>
        </div>
        <div className="flex items-center space-x-4">
          <a href="#" className="text-sm text-gray-500 hover:text-gray-700">Privacy Policy</a>
          <a href="#" className="text-sm text-gray-500 hover:text-gray-700">Terms of Service</a>
          <a href="#" className="text-sm text-gray-500 hover:text-gray-700">Contact</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;